import React, { useState, useEffect } from "react";
import { Markers } from "@wrstudios/components";
import Map from "../../common/Map";
import { setPreferredCompsSection } from "../utils/storage";
import { useLive } from "../LiveProvider";
import { useListingPreviewResizer } from "../listing/LiveListingPreview";
import LiveGuidanceMyRecentSalesDetailsModal from "./LiveGuidanceMyRecentSalesDetailsModal";
import {
  Container,
  Loading,
  LoadingPins
} from "./styled/live-guidance-my-recent-sales-map";

function LiveGuidanceMyRecentSalesMap() {
  const { myRecentSales, subjectProperty } = useLive();

  const { headerDetails } = useListingPreviewResizer();
  const [setPins] = useState([]);
  const [loadingPins] = useState(false);
  const [previewListingId, setPreviewListingId] = useState(null);

  const markers = useMarkers({
    previewListingId,
    setPreviewListingId
  });

  useEffect(() => {
    setPreferredCompsSection("map");
  }, []);

  useEffect(() => {
    const listing = myRecentSales.find(
      (listing) => listing.id === previewListingId
    );
    if (listing && previewListingId !== listing.recordId) {
      setPreviewListingId(listing.recordId);
      setPins((pins) =>
        pins.map((pin) => {
          return {
            ...pin,
            listings: pin.listings.map((l) => {
              if (l.id === previewListingId) {
                l.recordId = listing.recordId;
              }
              return l;
            })
          };
        })
      );
    }
  }, [previewListingId, myRecentSales, setPreviewListingId]);

  return (
    <Container>
      {loadingPins && (
        <LoadingPins>
          <Loading />
        </LoadingPins>
      )}
      <Map
        markers={markers}
        boundMarkers={markers}
        spLat={subjectProperty.coords.lat}
        spLon={subjectProperty.coords.lon}
        isAutoZoomDisabled
        isScrollZoomEnabled
        isInitialZoomDisabled
      />
      {previewListingId && (
        <LiveGuidanceMyRecentSalesDetailsModal
          style={{ top: headerDetails.bottom }}
          listingRecordId={previewListingId}
          initialTab="tour"
          showInModal={true}
          onClose={() => setPreviewListingId(null)}
        />
      )}
    </Container>
  );
}

function useMarkers({ previewListingId, setPreviewListingId }) {
  const { myRecentSales } = useLive();

  return myRecentSales.map((listing) => {
    const isSelected =
      listing.id === previewListingId || listing.recordId === previewListingId;
    return {
      id: listing.recordId,
      lat: listing.coords.lat,
      lon: listing.coords.lon,
      zIndex: isSelected ? 2 : null,
      component: (
        <Markers.ListingMarker
          isSelected={isSelected}
          price={listing.price}
          onClick={({ event, map }) => {
            event.stopPropagation();
            map.easeTo({ center: [listing.coords.lon, listing.coords.lat] });
            setPreviewListingId(listing.recordId);
          }}
          color="#9C1616"
        />
      )
    };
  });
}

export default LiveGuidanceMyRecentSalesMap;
